import { combineReducers } from 'redux';
import eventsReducer from './events';
import boothsReducer from './booths';
import boothTaxonomiesReducer from './boothTaxonomies';
import boothTiersReducer from './boothTiers';
import boothTabsReducer from './boothTabs';

export default combineReducers({
  events: eventsReducer,
  booths: boothsReducer,
  boothTaxonomies: boothTaxonomiesReducer,
  boothTiers: boothTiersReducer,
  boothTabs: boothTabsReducer,
});
